import _ from 'lodash'

export const isArrayEqual = <T extends Record<string, unknown>>(x: T[], y: T[]): boolean =>
  _(x).xorWith(y, _.isEqual).isEmpty()

export const isArrayEqualByKeys = <T extends Record<string, unknown>>({
  keys,
  next,
  prev,
}: {
  keys: (keyof T)[]
  next: T[]
  prev: T[]
}): boolean => {
  const prevFiltered: T[] = _.map(prev, (item: T): T => _.pick(item, keys))
  const nextFiltered: T[] = _.map(next, (item: T): T => _.pick(item, keys))

  return isArrayEqual<T>(prevFiltered, nextFiltered)
}
